import { gql } from '@apollo/client';

export const SET_NOT_FOUND =  gql`
  mutation setNotFound{
    setNotFound {
        _id
        isFound
        isManualMatchingSearchActive
    }
  }
`;
export const SET_NOT_FOUND_WITH_REASON =gql`
mutation setNotFoundWithReason( $reason: String!) {
  setNotFoundWithReason ( reason: $reason){
    _id
    isFound
    isManualMatchingSearchActive
  }
}
`;

export const SET_NOT_ACTIVE =gql`
mutation setNotActive {
  setNotActive {
    _id
    isFound
    isManualMatchingSearchActive
  }
}
`;
